import script from "./ConnectMetta.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectMetta.vue?vue&type=script&setup=true&lang=js"

import "./ConnectMetta.vue?vue&type=style&index=0&id=514ad79c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514ad79c"]])

export default __exports__